import {isNilOrEmpty} from 'ramda-adjunct';

import {Nullish} from 'shared/web';

export function isFieldVisible({
  showEmptyFields,
  isEnabledInAudit,
  value,
}: {
  showEmptyFields?: boolean;
  isEnabledInAudit: boolean | undefined;
  value: string | Nullish;
}) {
  if (!isEnabledInAudit) {
    return false;
  }
  if (!showEmptyFields && isNilOrEmpty(value)) {
    return false;
  }

  return true;
}
